import { Dropdown } from '@shared/components/dropdown';
import { MBIconV2 } from '@shared/components/image';
import { MBTextBody1, MBTextOverlineBold } from '@shared/components/typography';
import { Colors, grid } from '@shared/styles';
import { i18n } from '@shared/util/i18n';
import { List } from './List';
import { ControlOption } from './types';

interface AddMenuProps {
  title: string;
  onAdd(item: ControlOption): void;
  options: ControlOption[];
}

export function AddMenu({ title, onAdd = () => {}, options = [] }: AddMenuProps) {
  return (
    <Dropdown
      button={({ onClick }) => (
        <div
          onClick={onClick}
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            borderTop: `1px solid ${Colors.v2.gray10}`,
            paddingTop: grid(2),
            paddingBottom: grid(1),
            paddingLeft: grid(1),
            marginTop: grid(2),
            cursor: 'pointer',
          }}
        >
          <div style={{ display: 'flex', marginRight: grid(1) }}>
            <MBIconV2 color={Colors.v2.purple} name="plus" size={grid(3)} />
          </div>
          <MBTextBody1 color={Colors.v2.purple}>{i18n('common.add')}</MBTextBody1>
        </div>
      )}
      closeOnSelect
    >
      <div style={{ display: 'flex', marginBottom: grid(1), marginLeft: grid(1) }}>
        <MBTextOverlineBold color={Colors.v2.gray50}>{title}</MBTextOverlineBold>
      </div>
      <List options={options} onSelect={onAdd} />
    </Dropdown>
  );
}
